import React, { useEffect, useRef, useState } from 'react';
import '../../Static/Master/PackPrintStruct.css';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useMediaQuery, Button } from '@mui/material';
import ReactToPrint from 'react-to-print';
import { Grid, Paper } from '@mui/material';
import { fetchAdminSaleData, updateAdminSaleEntry } from '../../Store/PHPSlice/stockApi';
import { selectAdminSaleData } from '../Selectors/Master/OutwardSelectors';
import { fetchCompanyData } from '../../Store/PHPSlice/Firm';
import { selectFirm } from '../Selectors/Master/ItemSelectors';
import DropdownWithBtn from '../FieldsComponents/DropdownWithBtn';


const AdminSaleEdit = () => {
    const { Id } = useParams();
    const dispatch = useDispatch();
    const userdata = JSON.parse(sessionStorage.getItem('user'));
    const componentRef = useRef();
    const [selectedIds, setSelectedIds] = useState([]);
    const [deletedItems, setDeletedItems] = useState([]);
    const [formData, setFormData] = useState({
        ID: '',
        adsaleId: parseInt(Id),
        balamt: '',
        billNo: '',
        cgst: '',
        discnt_amt: '',
        discnt_type: '',
        discnt_val: '',
        dt: '',
        freight_ch: '',
        gst: '',
        gst_val: '',
        igst: '',
        netamt: '',
        other_ch: '',
        schlId: '',
        schlNm: '',
        sgst: '',
        totamt: '',
        totissqty: '',
        zoneId: '',
        zoneNm: '',
        firmId: '',
        firmNm: '',
        adrs: '',
        schladrs: "",
        firmph: '',
        fgst: '',
        schlph: '',
        totrate: '',
        sgstper: '',
        cgstper: '',
        igstper: '',
        schlcd: '',
        bankNm: '',
        ifsc: '',
        ac_no: '',
        branchNm: '',
        userId: userdata?.ID
    });
    const [packInfo, setPackInfo] = useState([]);
    const [selectFirmdata, setSelectFirmdata] = useState({});

    const packData = useSelector(selectAdminSaleData);
    const firmlist = useSelector(selectFirm);
    const isDesktop = useMediaQuery('(min-width:768px)');
    console.log(packInfo)
    useEffect(() => {
        dispatch(fetchAdminSaleData(Id));
        dispatch(fetchCompanyData());
    }, [Id, dispatch]);

    const dropdownlistDepartment = [
        {
            label: 'Item',
            id: 'item',
            options: [],
            value: formData.item,
            onChange: (newValue) => { },
            getOptionLabel: (option) => option.itemNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            handleAddNew: () => { },
            btnlabel: 'Add',
            sm: 4
        }
    ];

    useEffect(() => {

        if (packData?.data) {
            const item = packData?.data;
            const {
                ID,
                balamt,
                billNo,
                cgst,
                discnt_amt,
                discnt_type,
                discnt_val,
                dt,
                DT,
                freight_ch,
                gst,
                gst_val,
                igst,
                netamt,
                other_ch,
                schlId,
                schlNm,
                sgst,
                totamt,
                totissqty,
                zoneId,
                zoneNm,
                firmId,
                firmNm,
                fadrs,
                schladrs,
                firmgst,
                firmph,
                schlph,
                schlcd,
                bankNm,
                ifsc,
                ac_no,
                branchNm,
            } = item;
            const firmdata = firmlist?.data?.find(item => item.ID === firmId);
            setSelectFirmdata(firmdata);
            const info = packData.info;
            const totrate = info?.reduce((acc, sum) => acc + parseFloat(sum.srate), 0);
            let sgstper, igstper, cgstper;
            if (igst === '0') {
                sgstper = (parseFloat(gst_val) / 2);
                cgstper = (parseFloat(gst_val) / 2);
                igstper = 0;
            } else {
                igstper = gst;
                sgstper = 0;
                cgstper = 0;
            }
            setFormData(prev => ({
                ...prev,
                ID: ID,
                balamt: balamt,
                billNo: billNo,
                cgst: cgst,
                discnt_amt: discnt_amt,
                discnt_type: discnt_type,
                discnt_val: discnt_val,
                dt: DT,
                freight_ch: freight_ch,
                fgst: firmgst,
                gst: gst,
                gst_val: gst_val,
                igst: igst,
                netamt: netamt,
                other_ch: other_ch,
                schlId: schlId,
                schlNm: schlNm,
                sgst: sgst,
                totamt: totamt,
                totissqty: totissqty,
                zoneId: zoneId,
                zoneNm: zoneNm,
                firmId: firmId,
                firmNm: firmNm,
                adrs: fadrs,
                schladrs: schladrs,
                schlph: schlph,
                firmph: firmph,
                totrate: totrate,
                igstper: igstper,
                sgstper: sgstper,
                cgstper: cgstper,
                schlcd: schlcd,
                bankNm: bankNm,
                ac_no: ac_no,
                ifsc: ifsc,
                branchNm: branchNm
            }));
        }
        if (packData?.info && packData.info?.length > 0) {
            const info = packData.info;
            const clonedInfo = packData.info.map(item => ({ ...item }));
            const totrate = clonedInfo?.reduce((acc, sum) => acc + parseFloat(sum.srate), 0);

            setPackInfo(clonedInfo);
            // console.log(packData);
        }
    }, [packData]);

    const handleCheckboxChange = (checked, id) => {
        if (checked) {
            setSelectedIds((prev) => [...prev, id]);
            // console.log(selectedIds);
        } else {
            setSelectedIds((prev) => prev.filter((itemId) => itemId !== id));
            // console.log(selectedIds);
        }
        // console.log(selectedIds);
    };

    const handleSelectAll = (e) => {
        if (e.target.checked) {
            // Select all item.IDs
            const allIds = packInfo.map((item) => item.ID);
            setSelectedIds(allIds);
        } else {
            // Deselect all
            setSelectedIds([]);
        }
    };

    const handleInputChange = (index, field, value) => {
        const newValue = field === 'bqty' || field === 'srate' ? Number(value) : value;

        if (field === 'bqty') {
            const gqty = packInfo[index]?.gqty ?? 0;
            if (newValue > gqty) {
                alert(`Aavialable stock quantity is : ${gqty}`);
                return; // Stop the update
            }
        }

        const updated = [...packInfo];

        updated[index] = {
            ...updated[index],
            [field]: newValue
        };

        // Recalculate amount only if bqty or srate changed
        if (field === 'bqty' || field === 'srate') {
            const bqty = updated[index].bqty ?? 0;
            const srate = updated[index].srate ?? 0;
            updated[index].amt = parseFloat(bqty * srate);
        }

        const totqty = updated?.reduce((acc, sum) => acc + parseFloat(sum.bqty), 0);
        const totamt = updated?.reduce((acc, sum) => acc + parseFloat(sum.amt), 0);
        const disamt = Math.round((parseFloat(formData.discnt_val) / 100) * parseFloat(totamt));
        const grandTot = totamt - disamt
        const netamt = totamt - disamt + parseFloat(formData.gst_val) + parseFloat(formData.other_ch) + parseFloat(formData.freight_ch);
        let igst = 0, cgst = 0, sgst = 0;
        if (formData.gst === '1') {
            let gstval = Math.round(grandTot * (parseFloat(formData.gst_val) / 100));
            if (formData.igst !== '0') {
                igst = gstval;
            } else {
                const halfgst = Math.round(gstval / 2).toFixed(2);
                sgst = halfgst;
                cgst = halfgst;
            }
        }
        setPackInfo(updated);
        setFormData(prev => ({
            ...prev,
            totissqty: totqty,
            totamt: totamt,
            netamt: netamt,
            discnt_amt: disamt,
            igst: igst,
            cgst: cgst,
            sgst: sgst,
        }));
    };

    const handleDelete = () => {
        if (selectedIds.length === 0) return;

        // Filter items to delete and to keep
        const toDelete = packInfo.filter(item => selectedIds.includes(item.ID));
        const toKeep = packInfo.filter(item => !selectedIds.includes(item.ID));

        const totqty = toKeep?.reduce((acc, sum) => acc + parseFloat(sum.bqty), 0);
        const totamt = toKeep?.reduce((acc, sum) => acc + parseFloat(sum.amt), 0);
        const disamt = Math.round((parseFloat(formData.discnt_val) / 100) * parseFloat(totamt));
        const grandTot = totamt - disamt
        const netamt = totamt - disamt + parseFloat(formData.gst_val) + parseFloat(formData.other_ch) + parseFloat(formData.freight_ch);
        let igst = 0, cgst = 0, sgst = 0;
        if (formData.gst === '1') {
            let gstval = Math.round(grandTot * (parseFloat(formData.gst_val) / 100));
            if (formData.igst !== '0') {
                igst = gstval;
            } else {
                const halfgst = Math.round(gstval / 2).toFixed(2);
                sgst = halfgst;
                cgst = halfgst;
            }
        }
        // Update states
        setDeletedItems(prev => [...prev, ...toDelete]);
        setPackInfo(toKeep);
        setSelectedIds([]);
        setFormData(prev => ({
            ...prev,
            totissqty: totqty,
            totamt: totamt,
            netamt: netamt,
            discnt_amt: disamt,
            igst: igst,
            cgst: cgst,
            sgst: sgst,
        }));

        // console.log("Deleted items:", toDelete);
    };

    function numberToWords(num) {
        const below20 = [
            'Zero', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine',
            'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen',
            'Eighteen', 'Nineteen'
        ];
        const tens = [
            '', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'
        ];
        const thousands = ['', 'Thousand', 'Million', 'Billion', 'Trillion'];

        if (num === 0) return below20[0];

        let words = '';

        let i = 0;
        while (num > 0) {
            if (num % 1000 !== 0) {
                words = helper(num % 1000) + (thousands[i] ? ' ' + thousands[i] : '') + ' ' + words;
            }
            num = Math.floor(num / 1000);
            i++;
        }

        return words.trim().toUpperCase();

        function helper(n) {
            if (n === 0) return '';
            if (n < 20) return below20[n];
            if (n < 100) return tens[Math.floor(n / 10)] + (n % 10 !== 0 ? ' ' + below20[n % 10] : '');
            return below20[Math.floor(n / 100)] + ' Hundred' + (n % 100 !== 0 ? ' ' + helper(n % 100) : '');
        }
    };

    // Example usage:
    // console.log(numberToWords(123)); // Output: "One Hundred Twenty Three"
    // console.log(numberToWords(1234567)); // Output: "One Million Two Hundred Thirty Four Thousand Five Hundred Sixty Seven"
    // console.log(packInfo);

    // console.log(selectFirmdata);
    function postObj(packInfo, deletedItems, formData) {
        const data = {
            updatedData: packInfo,
            deletedData: deletedItems,
            totqty: formData.totissqty,
            totamt: formData.totamt,
            discnt_amt: formData.discnt_amt,
            igst: formData.igst,
            cgst: formData.cgst,
            sgst: formData.sgst,
            userId: formData.userId,
            adsaleId: formData.adsaleId,
            netamt: formData.netamt
        };
        return data;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        // if (formData.billNo === '') {
        //     alert('Please Enter Bill No.');
        //     return; // Stop form submission
        // }

        // if (formData.firm === '') {
        //     alert('Please Select Firm.');
        //     return; // Stop form submission
        // }
        const postobj = postObj(packInfo, deletedItems, formData);
        // console.log(postobj);

        dispatch(updateAdminSaleEntry(postobj))
            .unwrap()
            .then((result) => {
                // Handle success
                console.log('POST request successful!', result);
                alert("Admin Sale Updated");
                window.close();
                // You may want to update your component state or perform any other action
            })
            .catch((error) => {
                // Handle error
                console.error('Error while making POST request:', error);
                // You may want to display an error message to the user or perform any other action
            });

    };

    return (

        <Grid item xs={12}>
            <Paper>
                <div ref={componentRef} style={{ padding: '1%', marginBottom: '20px' }}>
                    {/* Heading */}
                    <h3 className="heading">Invoice Bill</h3>

                    {/* Upper part: Two tables side by side */}
                    <div className="flex-container">
                        {/* Left Table */}
                        <table>
                            <tbody>
                                <tr>
                                    <td><h2>{formData.firmNm}</h2>
                                        <b>Add.:</b>{formData.adrs}
                                        <br />
                                        <b>Contact:</b>{formData.firmph} <br />
                                        <b>GST No.:</b> {formData.fgst}
                                    </td>
                                </tr>
                                <tr>
                                    <td><h3>TO:</h3>
                                        {/* <b>School Name:</b><b style={{ color: 'blue' }}>{formData.schlNm} </b> <br /> */}
                                        <b>School Name:</b><b style={{ color: 'blue' }}> -</b> <br />
                                        <b>Code:</b><b style={{ color: 'blue' }}>{formData.schlcd} </b> <br />
                                        {/* <b>Add:</b> <span style={{ color: 'blue' }}>{formData.schladrs}</span> */}
                                        <b>Add:</b> <span style={{ color: 'blue' }}>-</span>
                                        <br />
                                        {/* <b>Contact:</b> <span style={{ color: 'blue' }}>{formData.schlph}</span> */}
                                        <b>Contact:</b> <span style={{ color: 'blue' }}></span>
                                    </td>
                                </tr>

                            </tbody>
                        </table>

                        {/* Right Table */}
                        <table>

                            <tbody>

                                <tr>
                                    <td>Bill No:</td>
                                    <td><b>{formData.billNo}</b></td>
                                </tr>
                                <tr>
                                    <td>Date:</td>
                                    <td>{formData.dt}</td>
                                </tr>
                                <tr>
                                    <td>Transport:</td>
                                    <td>{formData.trspt}</td>
                                </tr>
                                <tr>
                                    <td>Remark:</td>
                                    <td>{formData.remark}</td>
                                </tr>
                                <tr>
                                    <td>No. of Cartoons:</td>
                                    <td>{formData.parcelqty}</td>
                                </tr>
                                <tr>
                                    <td>Ship To:</td>
                                    <td>{formData.shtoNm}</td>
                                </tr>
                                <tr>
                                    <td>Ship Address:</td>
                                    <td>{formData.shtoadrs}</td>
                                </tr>

                            </tbody>
                        </table>
                    </div>
                    <Grid container alignItems="center" justifyContent="space-between" spacing={2}>

                        <Grid item xs={12} sm={2} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <div style={{ textAlign: 'right', margin: '10px 0' }}>
                                <Button variant="contained" color="primary" onClick={handleDelete}>
                                    Delete
                                </Button>
                            </div>
                        </Grid>
                    </Grid>

                    {/* Main Table */}
                    {packInfo.length > 0 &&

                        <table className="main-table">
                            <thead>
                                <tr>
                                    <th>
                                        <input
                                            type="checkbox"
                                            checked={packInfo.length > 0 && selectedIds.length === packInfo.length}
                                            onChange={handleSelectAll}
                                        />
                                    </th>
                                    <th>SR NO.</th>
                                    <th>PARTICULARS</th>
                                    <th>SIZE</th>
                                    <th>QTY</th>
                                    <th>RATE</th>
                                    <th>AMOUNT</th>
                                </tr>
                            </thead>
                            <tbody>
                                {packInfo.map((item, index) => (
                                    <tr key={index}>
                                        <td><input
                                            type='checkbox'
                                            checked={selectedIds.includes(item.ID)}
                                            onChange={(e) => handleCheckboxChange(e.target.checked, item.ID)}
                                        ></input></td>
                                        <td>{index + 1}</td>
                                        <td>{item.itemNm}</td>
                                        <td>{item.size}</td>
                                        <td>
                                            <input
                                                type="text"
                                                value={item.bqty}
                                                onChange={(e) => handleInputChange(index, 'bqty', e.target.value)}
                                                style={{ width: '60px' }}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                value={item.srate}
                                                onChange={(e) => handleInputChange(index, 'srate', e.target.value)}
                                                style={{ width: '60px' }}
                                            />
                                        </td>
                                        <td>{item.amt}</td>
                                    </tr>
                                ))}
                                <tr>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td><b>Total</b></td>
                                    <td><b>{formData.totissqty}</b></td>
                                    <td><b></b></td>
                                    <td><b>{formData.totamt}</b></td>
                                </tr>
                            </tbody>
                        </table>
                    }

                    {/* <Grid item xs={12} sm={10} marginBottom={2}>
                            <Grid container spacing={2} >
                                {
                                    dropdownlistDepartment && dropdownlistDepartment?.map((drop) => (
                                        <DropdownWithBtn
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                            handleAddNew={drop.handleAddNew}
                                            btnlabel={drop.btnlabel}
                                            handleDropdownOpen={drop.handleDropdownOpen}
                                            handleDropdownClose={drop.handleDropdownClose}
                                            sm={drop.sm}
                                        />
                                    ))
                                }
                            </Grid>
                        </Grid> */}

                    {/* Footer */}
                    <div className="flex-container">
                        <table>
                            <tbody>
                                <tr>
                                    <td>AMOUNT IN WORDS:
                                        <b>{numberToWords(parseFloat(formData.netamt))}</b>
                                    </td>


                                </tr>
                                <tr>
                                    <td>TOTAL QTY: <b> {formData.totissqty}</b></td>
                                </tr>


                                <tr>
                                    <td>Bank Name: <b> {formData?.bankNm}</b></td>



                                </tr>
                                <tr>
                                    <td>Account No.: <b> {formData?.ac_no}</b></td>
                                </tr>

                                <tr>
                                    <td>IFSC code: <b> {formData?.ifsc}</b></td>
                                </tr>

                                <tr>
                                    <td>Branch Name: <b> {formData?.branchNm}</b></td>
                                </tr>

                            </tbody>
                        </table>
                        <table>

                            <tbody>

                                <tr>
                                    <td><b>SUB TOTAL :</b></td>
                                    <td><b>{formData.totamt}</b></td>
                                </tr>
                                <tr>
                                    <td><b>DISCOUNT AMOUNT ({formData.discnt_val}{formData.discnt_type}) :</b></td>
                                    <td><b>{formData.discnt_amt}</b></td>
                                </tr>
                                <tr>

                                    <td><b>CGST({formData.cgstper}%)</b></td>
                                    <td>
                                        <b>{formData.cgst}</b>
                                    </td>
                                </tr>
                                <tr>

                                    <td><b>SGST({formData.sgstper}%)</b></td>
                                    <td>
                                        <b>{formData.sgst}</b>
                                    </td>
                                </tr>

                                <tr>

                                    <td><b>IGST({formData.igstper}%)</b></td>
                                    <td>
                                        <b>{formData.igst}</b>
                                    </td>
                                </tr>


                                <tr>

                                    <td><b style={{ color: 'red' }}>FREIGHT</b></td>
                                    <td>
                                        <b style={{ color: 'red' }}>{formData.freight_ch}</b>
                                    </td>
                                </tr>

                                <tr>

                                    <td><b>OTHERS</b></td>
                                    <td>
                                        <b>{formData.other_ch}</b>
                                    </td>
                                </tr>

                                <tr>

                                    <td><b style={{ color: 'blue' }}>GRAND TOTAL</b></td>
                                    <td>
                                        <b style={{ color: 'blue' }}>{formData.netamt}</b>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <Grid item xs={12} textAlign="center">
                        <Button variant="contained" color="primary" style={{ margin: '10px 0' }} onClick={handleSubmit}>Update</Button>
                    </Grid>
                </div>




                {/* <div style={{ margin: '2% 5%' }}>
                    <ReactToPrint
                        trigger={() => <Button variant="contained" color="primary">Print</Button>}
                        content={() => componentRef.current}
                    />
                </div> */}
            </Paper>
        </Grid>
    );
};

export default AdminSaleEdit;
